import { create } from 'zustand';

type ChargeStore = {
  isNeedCharge: boolean;
  setIsNeedCharge: (bool: boolean) => void;
  reset: () => void;
};

export const useChargeStore = create<ChargeStore>((set) => ({
  isNeedCharge: false,
  setIsNeedCharge: (bool: boolean) => {
    set({
      isNeedCharge: bool,
    });
  },
  reset: () => {
    set({ isNeedCharge: false });
  },
}));
